module.exports = __webpack_public_path__ + "img/16.b474a579.png";